import { Component } from "@angular/core";

@Component({
    selector: "app-no-active-change-order",
    standalone: true,
    imports: [],
    templateUrl: "./no-active-change-order.component.html",
    styleUrl: "./no-active-change-order.component.scss",
})
export class NoActiveChangeOrderComponent {
}
